import { motion } from "framer-motion";
import { MaskedLine, EASE } from "@/components/Reveal";

export default function PageHero({ title, subtitle, testid, compact = false }) {
  return (
    <header
      data-testid={testid}
      className="relative overflow-hidden bg-taupe/20 px-6 pb-16 pt-36 md:px-12 md:pb-24 md:pt-52"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-32 -top-24 h-[26rem] w-[26rem] rounded-full border border-rot/25"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-16 top-8 h-[26rem] w-[26rem] rounded-full border border-salbei/30"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -left-40 bottom-0 h-[22rem] w-[22rem] rounded-full bg-salbei/10"
      />
      <div className="mx-auto max-w-6xl">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
          className="mb-6 text-xs uppercase tracking-[0.4em] text-rot"
        >
          Dein Körper spricht mit dir
        </motion.p>
        <h1 className="font-serif font-normal leading-[0.95] tracking-tight text-rot">
          <MaskedLine delay={0.2} className={compact ? "text-3xl md:text-5xl lg:text-6xl" : "text-5xl md:text-7xl lg:text-8xl"}>
            {title}
          </MaskedLine>
        </h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.55, ease: EASE }}
            className="mt-6 max-w-xl font-serif text-xl italic leading-relaxed text-rot md:text-2xl"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </header>
  );
}
